import React from 'react';

// Initializing and exporting AppContext - common for whole application
export default React.createContext({});